import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';

const money = (v: any) => Number(v || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 });

type Props = { cards: any };

class BudgetVersionCardsPanel extends React.Component<Props> {
  render() {
    const c = this.props.cards || {};
    const items = [
      ['Versions', c.versions || 0],
      ['Open', c.openversions || 0],
      ['DG', c.dgversions || 0],
      ['CA', c.caversions || c.cavversions || 0],
      ['Adopted', c.adoptedversions || 0],
      ['Total Budget', money(c.totalbudget)],
      ['Lines', c.linecount || 0],
    ];

    return (
      <Grid container spacing={2}>
        {items.map(([label, value]) => (
          <Grid size={{ xs: 6, sm: 4, md: 1.7 }} key={String(label)}>
            <Card elevation={1}>
              <CardContent>
                <Typography variant="caption" color="text.secondary">{label}</Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>{value}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }
}

export default BudgetVersionCardsPanel;
